import { merge } from "lodash";
import Vue from "vue";
import VueI18n, { DateTimeFormat, LocaleMessages } from "vue-i18n";

import config from "./config";

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1].toLocaleLowerCase().replace("_", "-");

      messages[locale] = merge(locales(key), config.i18n.override[locale]);
    }
  });

  return merge(messages);
}

function matchingLocale(locale: string, availableLocales: string[]): string {
  for (let index = 0; index < availableLocales.length; index++) {
    const lang = availableLocales[index];

    if (lang.includes(locale.replace(/-\w+/, ""))) {
      return lang;
    }
  }
  return locale;
}

const baseDateTimeFormats: DateTimeFormat = {
  date: { year: "numeric", month: "long", day: "numeric" },
  dateShort: { year: "numeric", month: "2-digit", day: "2-digit" },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
  },
  time: { hour: "numeric", minute: "numeric", second: "numeric" },
};

const dateTimeFormats: VueI18n.DateTimeFormats = {
  de: baseDateTimeFormats,
  en: baseDateTimeFormats,
  fr: baseDateTimeFormats,
  it: baseDateTimeFormats,
};

const locale =
  window.localStorage.getItem("phellow:language") || navigator.language?.toLowerCase() || "de-ch";

const vuei18n = new VueI18n({
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-us",
  messages: loadLocaleMessages(),
  dateTimeFormats,
});

vuei18n.locale = matchingLocale(locale, vuei18n.availableLocales);

export default vuei18n;
